import { isValid, startOfMonth } from "date-fns";

export const resolveInitialPanelDate = (
	value: Date | null,
	minDate?: Date,
	maxDate?: Date,
): Date => {
	if (value !== null && isValid(value)) {
		return startOfMonth(value);
	}

	const today = startOfMonth(new Date());

	if (minDate !== undefined && today < startOfMonth(minDate)) {
		return startOfMonth(minDate);
	}

	if (maxDate !== undefined && today > startOfMonth(maxDate)) {
		return startOfMonth(maxDate);
	}

	return today;
};
